import React from 'react';
import { StreamComponent } from 'react/stream/StreamComponent.jsx';

class StreamsComponent extends React.Component {
	render() {
		const { streams, filterIsOnForStream, emptyContent } = this.props;
		const streamsToShow = streams.filter((stream) => {
			if(filterIsOnForStream && !filterIsOnForStream(stream)) {
				return false;
			}
			return true;
		});

		if(!streamsToShow.length && emptyContent) {
			return emptyContent;
		}
		return (
			<React.Fragment>
				{streamsToShow.map((stream) => (
					<StreamComponent
						matchStyle
						key={stream.id ? stream.id : stream.channel_name}
						stream={stream}
					/>
				))}
			</React.Fragment>
		);
	}
}

export { StreamsComponent };